import React, { Component } from 'react'
import { Field } from 'redux-form'

import { Container, Row, Col } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import HeadingBanner from 'components/Text/HeadingBanner'
import { Crumbs } from 'components/BreadCrumbs'
import { Input } from 'components/Input/Input'
import { Table, TableHeader, TableRow } from 'features/Table'
import Button from 'components/Button'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import Pagination from 'components/Pagination'
import { moment } from 'features/Moment'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'

export default class AdminUsersPage extends Component {
  componentWillMount() {
    const { getUsers, cacheKey, page, filterQuery } = this.props
    getUsers({ cacheKey, page, filterQuery })
  }

  componentWillReceiveProps(nextProps) {
    const { getUsers, cacheKey, page, filterQuery } = nextProps
    if (this.props.cacheKey && this.props.cacheKey !== cacheKey) {
      getUsers({ cacheKey, page, filterQuery })
    }
  }

  render() {
    const { users, switchUser, replace, page, query, showUsersSetRolesModal } = this.props
    const replaceUrl = params =>
      replace({
        pathname: location.pathname,
        query: {
          ...query,
          ...params,
        },
      })

    const tableHeader = (
      <TableHeader>
        <div>Name</div>
        <div>Username</div>
        <div>Roles</div>
        <div>Joined</div>
        <div style={{ maxWidth: '160px' }} />
      </TableHeader>
    )

    return (
      <Page layout={{ header: 'app' }} title="Admin">
        <PageHeader>
          <Crumbs title="Admin" />
          <HeadingBanner>
            <h3 className={cn(sText.heading3, sText.accent)}>Users</h3>
            <div className={sText.descrip1}>All the current Users</div>
          </HeadingBanner>
        </PageHeader>
        <Container paddingTop paddingBottom>
          <Row className={cn(sMarg.mb30, sLay['layout-row'], sLay['layout-align-end'], 'sm')}>
            <Col className="sm">
              <Field
                onChange={data => replaceUrl({ filterQuery: data.target.value })}
                label="Search"
                component={Input}
                name="filterQuery"
                display="box"
              />
            </Col>
          </Row>
          <Table header={tableHeader} style={{ position: 'relative' }}>
            {users.loading && users.data.length === 0 && <LoadingOverlay />}
            {users.data.map(user => (
              <TableRow key={user.id}>
                <div>
                  {user.firstName} {user.lastName}
                </div>
                <div>{user.username}</div>
                <div title={user.roles.join(', ')}>
                  {user.roles.map(role => role.replace('ROLE_API_', '')).join(', ')}
                </div>
                <div>{moment(user.addedAt).format('DD MMM YYYY, h:mm:ss a')}</div>
                <div style={{ maxWidth: '160px' }}>
                  <Button
                    color="tertiary"
                    size="xs"
                    onClick={() => showUsersSetRolesModal({ user })}
                    ghost
                    style={{ marginRight: '5px' }}
                  >
                    Roles
                  </Button>
                  <Button color="tertiary" size="xs" onClick={() => switchUser(user.id)}>
                    Login
                  </Button>
                </div>
              </TableRow>
            ))}
          </Table>
          <Pagination
            page={page}
            numPages={users.numPages}
            onClick={nextPage => replaceUrl({ page: nextPage })}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/AdminUsers/AdminUsers.jsx